import React, { useEffect, useRef, useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import IconKing from './icons/icon-king'
import Menu from './Menu'
import RightTooltip from '../RightTooltip'

/** Match Tailwind `xl` — collapse the rail below this width. */
const NAV_AUTO_COLLAPSE_MQ = '(max-width: 1279px)'

const Nav: React.FC = () => {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(NAV_AUTO_COLLAPSE_MQ).matches) {
      return true
    }
    return localStorage.getItem('navCollapsed') === 'true'
  })
  const wasSmallRef = useRef(
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(NAV_AUTO_COLLAPSE_MQ).matches
      : false
  )

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(NAV_AUTO_COLLAPSE_MQ)
    const apply = () => {
      const small = mq.matches
      if (small && !wasSmallRef.current) {
        setCollapsed(true)
      } else if (!small && wasSmallRef.current) {
        setCollapsed(localStorage.getItem('navCollapsed') === 'true')
      }
      wasSmallRef.current = small
    }
    mq.addEventListener('change', apply)
    return () => mq.removeEventListener('change', apply)
  }, [])

  const toggleCollapsed = () => {
    const next = !collapsed
    setCollapsed(next)
    localStorage.setItem('navCollapsed', String(next))
  }

  const collapseLabel = collapsed ? 'Expand sidebar' : 'Collapse sidebar'

  return (
    <div
      className={`relative flex flex-col flex-shrink-0 h-screen bg-slate-200 dark:bg-slate-800 border-0 border-gray-200 dark:border-0 text-gray-500 dark:text-gray-400 transition-all duration-200 ease-in-out overflow-hidden ${
        collapsed ? 'w-14' : 'w-64'
      }`}
    >
      <RightTooltip content={collapseLabel} enabled={collapsed} triggerClassName="w-full">
        <button
          onClick={toggleCollapsed}
          aria-label={collapseLabel}
          className={`flex items-center flex-shrink-0 w-full hover:bg-slate-300 dark:hover:bg-slate-700 transition-colors duration-200 ${
            collapsed ? 'justify-center flex-col py-2' : 'justify-between pr-2'
          }`}
        >
          <IconKing
            className={`text-indigo-800 dark:text-indigo-400 flex-shrink-0 ${
              collapsed ? 'w-8 h-8' : 'w-12 h-12 min-h-[48px] m-3'
            }`}
          />
          {collapsed
            ? <ChevronRightIcon className="w-4 h-4 mt-1 text-slate-500 dark:text-slate-400" />
            : <ChevronLeftIcon className="w-4 h-4 text-slate-500 dark:text-slate-400" />
          }
        </button>
      </RightTooltip>
      <Menu collapsed={collapsed} />
    </div>
  )
}

export default Nav
